/*
Determining user interactions:

We can determine if user interacts by listening to the following events:
- mousedown
- mousemove
- keydown
- scroll
- touchstart 
- click
- keypress
- touchmove

If any of these events are triggered it means it's a real user else it means it's either a bot like google, automated script or a search engine.


listen to user interaction events and dispatch a single custom event to listen to: */
(() => {
  let active = false;

  const dispatchActivity = () => {
    if (active) return;
    active = true;
    document.dispatchEvent(new CustomEvent("UserInteracted"));
  };

  const interact = () => {
    [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "keypress",
      "touchmove",
    ].forEach((event) => {
      window.addEventListener(event, dispatchActivity, false);
    });
  };

  if (document.readyState !== "loading") {
    interact();
  } else {
    document.addEventListener("DOMContentLoaded", interact, false);
  }
})();
